
import { getUnitByGoodsType } from '@/utils/common.js';
export default {
  props: {
    projectInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      announcement: '采购公告',
      citytitle: ''
    };
  },
  created () {
  },
  computed: {
    fundsShowText () {
      if (this.projectInfo && this.projectInfo.fundsInfo && this.projectInfo.fundsInfo.length) {
        let text = '';
        // this.projectInfo.fundsInfo.forEach(fund => {
        //   const fundsSource = fund.fundsSource && fund.fundsSource.toFixed(2);
        //   const fundsSourceProportion = fund.fundsSourceProportion && fund.fundsSourceProportion.toFixed(2);
        //   text += fund.fundsSourceDesc + '，' + fundsSource + '元，' + fundsSourceProportion + '%。';
        // });
        let tempList = [];
        this.projectInfo.fundsInfo.forEach(fund => {
          tempList.push(fund.fundsSourceDesc);
        });
        text = tempList.join('、');
        return text;
      } else {
        return '';
      }
    },
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 * 16 + 8 * 60 * 60 * 1000), 'yyyy年MM月dd日 hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  methods: {
    getUnitByGoodsType,
    formatDate (date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    }
  }
};
